module.exports = __webpack_public_path__ + "static/zem600l-6c6d1592e894f9b9ef5b16cca368b019.png";